import formatDecimalPoints from './formatDecimalPoints';

const secondsToHms = (timeInSeconds: number): string => {
  const hours = Math.floor(timeInSeconds / 3600) | 0;
  const minutes = Math.floor((timeInSeconds % 3600) / 60) | 0;
  const seconds = formatDecimalPoints(timeInSeconds % 60, 2);
  const [int, dec] = seconds.toString().split('.');

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${
    dec ? `${int.padStart(2, '0')}.${dec.padEnd(3, '0')}` : int.padStart(2, '0')
  }`;
};

export default secondsToHms;
